const STORE_KEY = 'SUBJECT_MENU'

export const FETCH_SUBJECT_MENU = `${STORE_KEY}/FETCH_SUBJECT_MENU`
